import styled from 'styled-components';
import { Tabs, Tab } from '@mui/material';
import { colorTheme } from './muiTheme';

export const LAYOUT_GLOBAL_TABS_LIST_HEIGHT = 48;

export const TabsWrapper = styled.div(
  ({ theme }) => `
  display: flex;
  align-items: center;
  width: 100%;
  height: ${LAYOUT_GLOBAL_TABS_LIST_HEIGHT}px;

  & > .MuiTabs-root {
    flex: 1;
    min-width: 0; 
  }

  & > .MuiBox-root {
    flex-shrink: 0;
    background-color: ${theme.palette.secondary.light};
    height: 100%;

    & > .MuiIconButton-root {
      flex-shrink: 0;
      margin: 0px 6px;
    }
  }
`);

export const TabsCustomized = styled(Tabs)(
  ({ theme }) => `&&  {
  background-color: ${theme.palette.secondary.light};

  & .MuiTabs-indicator {
    z-index: 1;
    background-color: ${theme.palette.yellow.main};
  };
}`,
);

export const TabCustomized = styled(Tab)(({ isActive }: { isActive: boolean }) => `&& {
  padding: 0;
  cursor: pointer !important;
  opacity: 0.8;
  color: ${isActive ? colorTheme.palette.primary.dark : ''};
  font-weight: ${isActive ? 700 : 400};
}`);

export const TabLabelWrapper = styled.div`
  position: relative;
`;

export const TabLabel = styled.div`
  display: flex;
  padding: 12px 26px 12px 16px;
  gap: 5px;
`;

export const CloseTab = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  right: 4px;
  top: 2px;
  bottom: 0;
  margin: auto;
  border-radius: 100%;
  display: flex;
  justify-content: center;

  &:hover {
    background: ${({ theme }) => theme.palette.secondary.main};
  }
`;

export const TabMenuPaper = styled.div`
  width: 320px;
  background: ${colorTheme.palette.common.white};
  z-index: 1;
`;